/* eslint-disable */
// 調整会議用メッセージ
export const dashboard = {
  I: {
    '001': '協力会社ユーザーを検索して追加',
    '002': '現場に追加するユーザー',
    '003': '名前で絞込み',
    '004': '職長の初期パスワードを再発行',
    '005':
      '以下の職長ユーザーは、登録された後、一度もBuildeeにログインしていません。本当に現場招待してもよろしいでしょうか？',
    '006': '＜Buildee未ログインの職長ユーザー＞',
    '007':
      '※現場招待した後は、必ず【職長本人】にIDと初期パスワードを伝えて、Buildeeにログインしてもらうようにしてください。',
    '008': 'Buildee未ログインの職長ユーザーの確認',
    '009': 'CO2情報入力',
    '010':
      '※CO2測定のため、必ず入力してください。入力にあたっては各元請様のルールに従ってください。',
    '011': '所属元請会社／協力会社',
    '252': '※半角英数で入力してください。メールアドレスは使用できません。',
    '253':
      '大文字・小文字・数字・それぞれを含む、\n半角英数8~32文字で入力してください',
    '302': '{0}予定の削除',
    '303': '前回登録した内容をコピー',
    '304': '選択した{0}予定を承認しますか？',
    '305': '選択した{0}予定の承認を解除しますか？',
    '306': '※承認者が0人のデータは編集できるようになります。',
    '308': '※既存のデータには影響しません。',
    '309': '当日を含む未来日を選択してください。',
    '310': '禁止時間帯設定を解除しますか？',
    '311': '禁止時間帯設定を解除しました。',
    '312': '選択された{0}は全て承認済みです。',
    '313': '選択された{0}は全て承認解除済みです。',
    '314': 'オペレータ設定を解除しますか？',
    '315': '選択した作業{0}の承認を解除しますか？',
    '316': '実績に反映する',
    '317': '{0}の作業予定を実績に反映',
    '318': '※ファイル数は5枚まで登録可能です。',
    '319': 'アップロードが完了すると、登録画面に進みます。',
    '320': 'この巡回記録（安全指摘事項）を是正確認完了とします。よろしいですか？',
    '321': 'この巡回記録/各種連絡を削除します。よろしいですか？',
    '322': 'すでにコピー済みです。',
    '351': '実績に反映',
    '352': '実績に反映しました',
    '353': '承認を解除',
    '354': '承認を解除しますか？',
    '355': '承認解除',
    '356': '既に反映されているデータです',
    '402': '入力したメールアドレス宛に、招待メールを送信します。よろしいですか？',
    '403': '協力会社の職長を登録します。よろしいですか？',
    '404':
      '承認すると編集ができなくなります。選択した{0}を承認してよろしいですか？',
    '405':
      '承認者が0人になると編集が可能になります。選択した{0}の承認を解除してよろしいですか？',
    '406': '{0}の作業予定を作業実績に反映します。よろしいですか？',
    '407': '{0}の承認',
    '408': '{0}の承認解除',
    '409': '是正報告を承認してよろしいですか？',
    '410':
      '否認すると再度是正報告を行えるようになります。否認してよろしいですか？',
    '411': '是正報告の承認を解除してよろしいですか？',
    '412': '是正内容を入力せずに承認済の状態にします。よろしいですか？',
    '413': '選択した協力会社を承認してよろしいですか？',
    '414': '招待中のすべての協力会社の承認を元請に依頼します。よろしいですか？',
    '415':
      '{0}すると編集ができなくなります。選択した作業{1}を{0}してよろしいですか？',
    '416':
      '承認者が0人かつ{0}解除になると編集が可能になります。選択した作業{1}の{2}を解除してよろしいですか？',
    '417':
      '承認を解除すると編集が可能になります。選択した{0}の承認を解除してよろしいですか？',
    '418': '※パスワードを忘れた場合に再設定する際の通知先になります。',
    '419': '初期パスワードの再発行完了',
    '420': '選択した職長ユーザーの初期パスワードの再発行が完了しました。',
    '421':
      '以下のユーザーは本現場での作業を終了している、もしくはステータスが停止中となっているため、通知が送信されませんでした。',
    '422': '協力会社の登録',
    '423': '選択した協力会社を否認してもよろしいですか？',
    '424': '選択した協力会社の承認依頼',
    '425': '選択した協力会社の承認依頼取り消し',
    '426':
      '作業を終了した協力会社のユーザーはこの現場にアクセスできなくなります。',
    '427':
      '作業終了が取り消された協力会社のユーザーはこの現場にアクセスできるようになります。',
    '428': '選択した会社のみ取り消す',
    '429': '下位協力会社も一括で取り消す',
    '430': '作業終了を取り消す',
    '431': '以下の許可情報は、Buildee労務安全で利用されています。',
    '432':
      '削除した場合も、作成済の労務安全書類には影響がありません。\n次回、書類更新をした際に削除した許可情報が労務安全書類に反映されなくなります。\n\nこのまま許可情報を削除してもよろしいですか？',
    '433': 'このまま削除する',
    '434': '一部情報がコピーできませんでした',
    '435':
      '選択した{0}内の元請担当者が作業終了または停止されています。\n作業終了・停止しているユーザーは元請担当者に設定できないため、未選択状態でコピーされました。\nコピーされたデータの元請担当者をご確認ください。',
    '436': '現場での管理用にご利用ください。',
    '437': '機材のリース番号などがあればご利用ください。',
    '438': '{0}情報の削除完了',
    '439': '選択した{0}情報の削除が完了しました。',
    '440': '{0}一覧を出力する',
    '441': '{0}の情報が{1}件を超えていますので、ファイルを分割して出力します。',
    '442': '下記のリンクをクリックしてダウンロードしてください。',
    '443': '{0}一括取り込み完了',
    '444': '{0}一括取り込みが完了しました。',
    '445':
      'エラーのデータがあります。エラー箇所を確認し、ファイルを修正してください。',
    '446': '削除確認',
    '447': '{0}一括取り込みに失敗しました',
    '448': '{0}の削除に失敗しました',
    '449': 'パスワードを表示する',
    '450':
      '※CCUS事業者IDやCCUS管理者IDは、CCUSに事業者情報を登録したときの下記お知らせから確認することができます。',
    '451': 'CCUS連携情報の削除確認',
    '452':
      '「CCUS基本情報」および「その他管理者」情報を削除します。\n本当によろしいですか？',
    '453': '接続確認に成功しました。',
    '454':
      'CSVデータは現時点の最新の集計データを出力します。そのため、画面に表示されているデータと出力したCSVデータの内容が異なる場合がございます。',
    '455':
      '会社で取得したCCUS事業者IDと登録責任者の管理者ID、パスワード（またはセキュリティコード）を入力してください。',
    '456':
      'CCUSにログインできる管理者IDと、パスワード（またはセキュリティコード）を入力してください。',
    '457':
      '「CCUSログインパスワード」はパスワード、セキュリティコードどちらを設定いただいても連携をおこなえますが、セキュリティの観点からセキュリティコードでの登録を推奨しております。',
    '458':
      '以下のJV構成会社を現場から削除します。\n削除された会社のユーザーは現場にアクセスができなくなります。\nアクセスができなくなったユーザーはメールで通知されます。\n\n・会社名：{0}\n・支店名：{1}\n・住所：{2}\n\n本当に現場から削除してよろしいですか？',
    '459':
      '以下のJV構成会社を現場に追加します。\n追加された会社の本社管理者と対象の支店管理者ユーザーは現場にアクセスが可能になり、現場監督の招待をおこなうことができるようになります。\nアクセスが可能になったユーザーはメールで通知されます。\n\n・会社名：{0}\n・支店名：{1}\n・住所：{2}\n\n本当に追加してよろしいですか？',
    '500': 'JV構成会社を現場から削除しますか？',
    '501': 'JV構成会社を追加しますか？',
    '502': 'JV構成会社を削除できません',
    '503': 'JV構成会社の登録が完了していません',
    '504':
      '登録が完了していないJV構成会社があります。\nこのまま画面遷移してもよろしいですか？',
    '505':
      '証明写真のスキャンや、認証不良となる写真を登録している場合は、必ず再登録してください。\n登録基準外の写真は、別の人として認証されるなど、誤認証の原因となります。\n\n※スマートフォン、タブレットのカメラで撮影することをお勧めします。\n画像サイズが縦 1280px 以上、横 1280px 以上推奨。\n（最新のスマートフォン、タブレットのカメラのデフォルト設定では、縦 1280px 以上、横 1280px 以上で撮影可能です）\n顔全体が大きく写っている。',
    '506':
      '登録内容が変更されました。\n画面を再読み込み後、再度操作を行なってください。',
    '507': '機材予定のコピー',
    '508':
      '以下の注意事項をご確認ください。\n\n＜注意事項＞\n・施工体制情報が手動、自動問わずCCUSへ送信できなくなります。\n　Buildeeの施工体制に協力会社や作業員を追加してもCCUSに反映されません。\n・連携状況を「停止」にしても入退場実績の送信は行われます。\n　入退場実績の送信を停止したい場合には、CCUS現場IDを削除してください。\n \n本当に停止してよろしいですか？',
    '509': '※編集内容が多い場合、更新処理に時間がかかることがあります。',
    '510':
      '一部の項目で一括編集を行うことができます。\n一度に編集できる作業{0}は最大{1}件です。\n編集可能な項目は支店ごとに「一覧表示設定」から設定してください。',
    '511':
      'IOSやiPadOSのバージョンが13以下の場合、本機能をご利用いただけません。\nPCをご利用いただくか、OSのアップデートをご検討ください。',
    '512':
      '※「生コンクリート」／「アスファルト」選択時は荷種欄は編集できません。補足情報は備考欄に記載してください。\n　それ以外の資材は「その他」を選択した上で記入してください。',
    '513': '代行登録先のCCUS基本情報の登録に失敗しました。',
    '514': '会社名をご確認ください。',
    '515': 'セキュリティコードを表示する',
    '516':
      '登録する会社の事業者IDと登録責任者の管理者ID、セキュリティコードを入力してください。',
    '517':
      '更新する会社の事業者IDと登録責任者の管理者ID、セキュリティコードを入力してください。',
    '518':
      '会社間でCCUSのパスワードを共有する行為は、セキュリティの関係上お控えください。',
    '519': '登録する会社のCCUS管理者IDとセキュリティコードを入力してください。',
    '520': '更新する会社のCCUS管理者IDとセキュリティコードを入力してください。',
    '521':
      '※管理者IDとパスワードの組み合わせの場合、CCUSにログインできることをご確認ください。',
    '522': '※管理者ID、セキュリティコードを確認のうえ正しく入力してください。',
    '523':
      'LINE WORKSとの連携を行います。ご利用には、別途LINE WORKSのアカウントが必要です。',
    '524': 'トークルームの設定はできません',
    '525':
      'トークルームの設定画面を表示するためには、操作ユーザーがグループに所属している必要があります。操作ユーザーをグループに所属させてからもう一度操作してください。',
    '526': '連携解除',
    '527': 'LINE WORKSとの連携を解除します。よろしいですか？',
    '528': '解除する',
    '529': 'LINE WORKSとの連携を解除しました。',
    '530': 'direct連携中です。',
    '531': 'directとの連携を行います。ご利用には、別途directのアカウントが必要です。',
    '532':
      'directの組織情報をBuildeeに登録します。ご利用には、別途directのアカウントが必要です。',
    '533':
      'ご利用になる現場のdirect組織にBuildeeBOTを招待します。ご利用には別途directのアカウントが必要です。',
    '534': '連携完了しましたら、画面が連携中に変化します。',
    '535': 'direct組織情報を登録',
    '536':
      '現場で利用するdirectの組織情報を登録します。\ndirectから組織情報を取得するためには、「登録」ボタンからログインしてください。\n保留にする場合は、「閉じる」ボタンを押してください。',
    '540':
      'ログインに必要な登録情報をご準備ください。\n「移動」ボタンで外部サイトに移動します。',
    '541': '未対応一覧',
    '542': '(全作業時間帯 / 過去30日間)',
    '543': '実績未確定一覧',
    '544': '実績未承認一覧',
    '545': '予定未受領一覧',
    '546': '予定未承認一覧',
    '547': '一度に{0}できる{1}の上限は{2}件です。\n選択数を{2}件以下にしてください。',
    '548':
      '表示している場合は、自動ロックされています。自動ロックを解除し承認することで未対応ではなくなります。',
    '549':
      '同一施工体制に作業実績が複数件ある場合は先頭行にのみ数値が表示されます。',
    '550': '組織情報取得に成功',
    '551': '「次へ」ボタンを押すと、組織の選択画面を表示します。',
    '552': 'BuildeeBOTを招待',
    '553':
      '連携するにあたって、お客様がご利用になるdirectの組織にBuildeeBOTを招待していただく必要があります。招待に必要な情報は以下の通りです。',
    '554': 'メールアドレス：',
    '555': '役割：ユーザー',
    '556':
      '招待が完了したら、「次へ」を押してください。\n保留にする場合は、「閉じる」ボタンを押してください。',
    '557': 'BuildeeBOT招待の確認',
    '558':
      '現場で利用するdirectの組織にBuildeeBOTを招待済でしょうか。\n招待が完了してる場合は「招待済」を、まだ未招待の場合は「戻る」を押してください。',
    '559': 'direct連携設定を完了',
    '560': 'お客様のdirect組織へBuildeeBOTが追加され、direct連携が利用可能となりました。',
    '561': 'direct組織を登録',
    '562': '現場で利用するdirect組織を選択し、登録してください。',
    '563': '登録画面を閉じる',
    '564':
      '途中経過は保存されず、directログインからやり直しになります。本当に登録画面を閉じてよろしいでしょうか。',
    '565': '登録に成功',
    '566':
      '登録したdirectの組織にはBuildeeBOTが存在しています。\nこのまま利用可能です。',
    '567': 'direct連携を中止',
    '568':
      '中止した場合、連携設定は初期状態にリセットされます。\n本当にdirectとの連携を中止してもよろしいでしょうか。',
    '569': '中止',
    '570': 'direct連携設定を中止しました。',
    '571': 'directの組織にBuildeeBOTを招待してください。',
    '572': '招待情報を確認',
    '573': 'メッセージ通知設定',
    '574':
      '作業予定・作業実績の未対応の人たちへのdirectメッセージ通知の設定ができます。\n通知したいトークルームを選択し、通知時間を設定ください。\n※Buildee側の状況によっては指定した時刻より遅れて届く場合がございます。',
    '575': '通知設定ができません',
    '576':
      '協力会社承認機能がオフになっています。\n機能をオンにしてからメッセージ通知設定を行ってください。\n現場一覧＞現場の「編集」ボタン＞現場詳細画面の「編集」ボタン＞協力会社承認機能',
    '577': 'メッセージ通知停止',
    '578': 'メッセージ通知を停止します。よろしいでしょうか。',
    '579': 'トークルームのメッセージ通知設定を行います。よろしいでしょうか。',
    '580': '登録済み',
    '581': '招待済',
    '582': 'direct連携停止の確認',
    '583':
      '登録したdirect組織情報も削除されます。\n本当に連携を停止してもよろしいでしょうか。',
    '584': 'direct連携を停止',
    '585': 'directとの連携を停止しました。',
    '586': '共有リンク',
    '587': '共有リンクの設定が完了しました。',
    '588': '共有ファイル',
    '589': '共有ファイルの設定が完了しました。',
    '590': '共有ファイルの削除',
    '591': '共有ファイルを削除します。よろしいでしょうか。',
  },
  W: {
    '001':
      'ユーザーIDを変更した場合は強制的にログアウトされ、再度ログイン画面からの操作となります。\nログイン画面表示後は、変更後のユーザーIDを入力してログインしてください。\nユーザーIDを変更しますか？',
    '301':
      '現在編集中のデータを上書きします。よろしいですか？　\n※この操作は取り消せません。',
    '302': '作業予定で使用されている場合がありますが削除しますか？',
    '303':
      '作業員が2人以上登録されています。\n従業員を雇用している場合には、「一人親方ではない」を選択してください。',
    '304':
      '支店情報が登録されている協力会社は一人親方に設定することはできません。\n支店情報から支店を停止することで、一人親方に設定することができます。\n支店の停止は企業管理者ユーザーのみが行えます。',
    '305': '高車管理から連携された機材予定はコピーできません。',
    '306': '高車管理から連携された機材予定はコピーされません。',
    '307':
      '2025年07月27日のリリースにて、この画面の「案内図（PDF）」と「その他現場資料」は編集してもダッシュボードに反映されなくなりました。\nリリース以前に登録されたデータはダッシュボードの共有ファイルに移行されています。ダッシュボードの共有ファイルにて編集を行ってください。\nなお、この画面の「案内図（PDF）」と「その他現場資料」は将来的に廃止を予定しております。',
    '308': '警告',
    '309':
      '対象の現地KYが一時保存になっています。こちらの作業終了報告の確認を実施しますか？',
  },
  E: {
    '001': 'この操作をする権限がありません。',
    '002': '登録できるユーザーがいません',
    '003': '職種が未設定のユーザーが存在します',
    '004': '対象となる職長がいません',
    '005': '既に登録されています',
    '006': '元請を選択してください',
    '007': '自身のユーザー種別を変更することはできません。',
    '008':
      'ログインされたアカウントは現在停止されており、Buildeeをご利用できません。\nアカウント停止の解除については、自社の管理者までお問い合わせください。',
    '102':
      'この協力会社には管理者がいないため、職長ユーザーの登録ができません。協力会社管理者を登録してから行ってください。',
    '103':
      '1度もログインしていない職長ユーザーが含まれています。ログイン後に改めて現場に追加してください。',
    '104':
      '外国人建設就労者の在留資格は2023年3月31日に終了しました。他の在留資格に変更された場合は、該当する在留資格を選択してください。',
    '105': '期限切れの情報があります。',
    '106': '期限切れ間近の情報があります。',
    '107': '在留資格を変更してください。',
    '108': '作業員在留資格情報が取得できませんでした',
    '202': '協力会社を選択してください',
    '203': '選択できるファイルは最大5枚です。',
    '251': '指定された作業日に稼働日が含まれていません。',
    '301': '{0}女性数が不正です。',
    '302': '{0}外国人数が不正です。',
    '303': '30日以上は選択できません。',
    '304': '開始日が終了日より後の日付になっています。',
    '305': 'スポット時間が終了時刻を超えています。',
    '306': 'スポット時間が不正です。',
    '307': '禁止時間帯が設定されていません。',
    '308': 'このデータは削除できません',
    '309':
      '現場内の登録データに使用されているため削除できません。\nステータスを未使用に切り替えることでデータ登録時に非表示にできます。',
    '310': '「指摘された日」から「当日」までの間の日付を設定して下さい。',
    '311': '過去の日付は入力できません。',
    '312':
      'この画像に対する巡回記録/各種連絡の登録を取りやめます。入力した内容も削除されますがよろしいですか？',
    '313': '開始日が現在日より前の日付になっています。',
    '314':
      'ファイルアップロードの上限は1枚のみの場合は10MB、2枚以上の場合は7MBです。',
    '315': '作業予定が削除されています。',
    '351': '一括承認解除',
    '352': '解除権限が無い一部のデータについては、承認解除できませんでした',
    '353':
      '帳票出力できる上限を超えました。印刷対象データを絞り込んで、再度実行してください。',
    '354':
      '印刷に失敗したため、5秒後に再度画面を読み込みます。\n再読み込み後に印刷をお願いいたします。',
    '355': '開始日を指定してください',
    '356': '終了日を指定してください',
    '357': '終了日は開始日より前に指定してください',
    '358': '印刷対象期間は1か月以内になるように指定してください',
    '359': '開始日/終了日を入力してください。',
    '360': '期間指定は1週間以内で指定してください。',
    '361': '1週間を超えての期間指定はできません。',
    '400': '現場未選択のため表示できません。現場を選択してください。',
    '401':
      '有効期限が切れているため、PDFの内容を表示できません。再度、帳票出力してください。',
    '402': 'エラーが発生しました',
    '403': 'お手数ですが、再度初期パスワードの再発行を行ってください。',
    '410':
      '帳票出力できる上限を超えました。\n印刷対象データを絞り込んで、再度実行してください。',
    '411':
      '帳票出力の対象がありません。\n検索結果を表示して、再度実行してください。',
    '412':
      '帳票のページ数が150ページを超えたため出力できません。\n印刷対象データを絞り込んで、再度実行してください。',
    '413': '印刷対象の帳票がありません。',
    '414':
      '帳票の出力処理でエラーが発生しました。\nシステム管理者までお問い合わせください。',
    '415': '帳票出力エラー',
    '416': '保険開始日が保険終了日より後の日付になっています。',
    '417': '保険終了日が保険開始日より前の日付になっています。',
    '418': '未来の日付が入力されています。現在より過去の日付を入力してください。',
    '419':
      '有効期限が切れています。許可の更新を行っている場合、入力情報の更新をしてください。',
    '420': '作業終了の取消に失敗しました',
    '421':
      '上位協力会社が作業終了されているため、作業終了を取り消すことができませんでした。先に上位協力会社の作業終了を取り消してください。',
    '422': '元請担当者の登録に失敗しました',
    '423':
      '元請担当者に設定したユーザーが作業終了または停止されています。\n作業終了・停止しているユーザーは元請担当者に設定できないため、選択しなおしてください。',
    '424':
      '{0}予定で使用されている{0}が含まれており、一部の{0}が削除できませんでした。\n今後使用しない場合にはステータスを未使用に変更してください。',
    '425': 'エラーが発生しました。再度操作を行ってください。',
    '426': '削除に失敗しました',
    '427':
      '既にCCUS連携に利用されているため、CCUS連携情報を削除できません。\n削除が必要な場合は、カスタマーサポートまでお問い合わせください。',
    '428': '接続確認に失敗しました',
    '429': '作業場所の設定上限を超えています',
    '430': 'データが変更されました',
    '431': '選択された巡回記録は既に削除されています。',
    '432': '巡回記録一覧に戻る',
    '433':
      'エラーが発生しました。会社情報を開きなおし、再度操作を行ってください。',
    '434':
      '一人親方は支店を作成することができません。\n支店を利用する場合には、本社情報タブから「一人親方ではない」を選択してください。',
    '435': 'ゲート予定車両編集',
    '436':
      '他のユーザーによって編集が行われたため、処理に失敗しました。\n閉じるボタンを押下すると画面が更新されます。ご確認のうえ改めて操作を行ってください。',
    '437':
      '更新に失敗しました。\n\n同時に操作しているユーザーが作業員の追加状況を変更しています。\n最新の登録状況をご確認いただき、再度操作をお試しください。',
    '438': 'LINE WORKSとの連携解除に失敗しました。',
    '439': '確定に失敗しました',
    '440': '一括承認に失敗しました',
    '441': '一括確定に失敗しました',
    '442':
      '人工が入力されていません。\n人工が未入力の作業実績は承認ができないため、人工を入力してください。',
    '443':
      '選択された作業実績に人工が未入力のデータが含まれています。\n人工が未入力の作業実績は承認ができないため、人工を入力してください。',
    '444':
      '人工が入力されていません。\n人工が未入力の作業実績は確定ができないため、人工を入力してください。',
    '445':
      '選択された作業実績に人工が未入力のデータが含まれています。\n人工が未入力の作業実績は確定ができないため、人工を入力してください。',
    '446': '承認に失敗しました',
    '447': '情報取得に失敗',
    '448':
      'direct組織情報取得に失敗しました。\n再度最初から操作をやり直してください。',
    '449': 'directの利用停止に失敗しました。',
    '450': '画面遷移に失敗しました',
    '451':
      '協力会社承認機能がONでないと表示できない画面です。\n設定がOFFのため画面遷移に失敗しました。ダッシュボードに遷移します。',
    '452':
      '現在、協力会社承認機能がオフになっておりメッセージ通知を行うことができません。再開するには、協力会社承認機能をオンにしてください。',
    '453':
      '別ユーザーによりオペレーターを登録済みのため登録できませんでした。\n画面を再読み込みします。\n登録内容をご確認ください。',
    '454': '登録に失敗',
    '455': '一部の承認操作に失敗しました。',
    '456':
      '一度に承認できるのは2000件までです。\n2001件目以降の承認に失敗していますので、再度選択して承認操作を行ってください。',
    '457': '一部の承認解除操作に失敗しました。',
    '458':
      '一度に承認解除できるのは2000件までです。\n2001件目以降の承認解除に失敗していますので、再度選択して承認解除操作を行ってください。',
    '459':
      '登録内容が変更されました。\n画面を再読み込み後、再度操作を行ってください。',
    '460': '前回登録した内容へのアクセス権がなくなったため、コピーできません。',
    '461': '共有リンクの設定が失敗しました。',
    '462': '共有ファイルの設定が失敗しました。',
    '463': '他のユーザーが更新を行ったため更新することができません。',
    '464': 'エラーが発生しました。',
    '465':
      '操作中の現場は安全記録機能が使用できません。Buildee管理者にお問い合わせください。',
    '466':
      '大変申し訳ございません。現在ご使用中の権限では指定されたページを開くことができません。Buildee管理者にお問い合わせください。',
    '467': '印刷できません',
    '468':
      '{0}件の現地KYが選択されています。\n一度に出力できる現場KYは100件までとなります。',
    '469':
      '対象の現地KYは一時保存の状態のため、現在は操作できません。再提出が完了するまでお待ちください。',
    '470':
      '登録内容が変更されました。画面を再読み込み後、再操作を行ってください。',
  },
};



// WEBPACK FOOTER //
// ./src/utilities/messages/dashboard.js